import classNames from "classnames";
import { ErrorWrapper } from "components/ErrorWrapper";
import { Layout } from "components/Layout";
import { Seo } from "components/Seo";
import { WidgetsRenderer } from "components/WidgetsRenderer";
import { PageDataProvider } from "shared/contexts/PageData";

import styles from "./FixedPage.module.scss";

const defaultDebugData = {};
export function FixedPageTemplate({
  data,
  templatedData,
  collectedData,
  error,
  debugData,
}) {
  return (
    <ErrorWrapper error={error}>
      <PageDataProvider value={{ data, collectedData, debugData }}>
        <Layout>
          <Seo data={templatedData.seo} />
          <WidgetsRenderer
            registry="layout-widget"
            items={templatedData.hero}
          />
          <WidgetsRenderer
            registry="content"
            items={data.content}
            className={classNames({
              [styles["article-wrapper"]]: data.pageOwnData?.articleCategories,
            })}
          />
          <WidgetsRenderer
            registry="layout-widget"
            items={templatedData.content}
          />
        </Layout>
      </PageDataProvider>
    </ErrorWrapper>
  );
}
